module.exports = "/_next/static/images/SergeyBogutsky-9d867c63d8f89c86a953dc7703e5d19d.webp";